var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rights-page"},[(_vm.payShow)?_c('p',{staticClass:"rights-page_title"},[_c('van-icon',{attrs:{"name":"checked"}})],1):_vm._e(),_c('h2',[_vm._v(_vm._s(_vm.payResult))]),_c('van-overlay',{attrs:{"show":_vm.loading}},[_c('van-loading',{staticClass:"loadingDiv",attrs:{"size":"40","vertical":""}},[_vm._v("支付结果查询中...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }